import { Controller } from '@hotwired/stimulus';
import { slideToggle } from '../helpers';
import Axios from '../axios';

export default class extends Controller {
	static get targets () {
		return ['couponToggle', 'couponSummary', 'couponSubmit', 'couponCode', 'couponDiscount', 'couponTotalDiscount', 'couponTotalPrice', 'agreementGroup', 'planTitle', 'planPrice', 'codeInput'];
	}

	connect() {
		this._lang = document.documentElement.lang.split('-')[0];
		this.toggleTitle();
	}

	couponToggleTargetConnected () {
		this.couponToggleTarget.addEventListener('click', () => {
			this.toggleCouponCode();
		});
	}

	couponSubmitTargetConnected () {
		this.couponSubmitTarget.addEventListener('click', () => {
			this.submitCouponCode();
		});
	}

	couponCodeTargetConnected () {
		this.couponCodeTarget.addEventListener('keypress', (e) => {
			if (e.keyCode === 13) {
				e.preventDefault();
				this.submitCouponCode();
				return false;
			}
		});
	}

	agreementGroupTargetConnected () {
		const checkboxes = this.agreementGroupTarget.querySelectorAll('input[type="checkbox"]');
		checkboxes.forEach(checkbox => {
			checkbox.addEventListener('change', () => {
				if (checkbox.classList.contains('single')) {
					checkboxes.forEach(cb => {
						if (cb !== checkbox) {
							cb.checked = false;
						}
					});
				} else {
					checkboxes.forEach(cb => {
						if (cb.classList.contains('single')) {
							cb.checked = false;
						}
					});
				}
			});
		});
	}

	toggleCouponCode() {
		slideToggle(this.couponSummaryTarget);
		this.couponToggleTarget.classList.toggle('active');

		if (this.couponToggleTarget.classList.contains('active')) {
			this.couponToggleTarget.querySelector('span').innerText = this.couponToggleTarget.dataset.hideText;
		} else {
			this.couponToggleTarget.querySelector('span').innerText = this.couponToggleTarget.dataset.showText;
		}
	}

	async submitCouponCode() {
		const element = this.couponSubmitTarget;
		const couponCodeInput = this.couponCodeTarget;
		const couponCode = couponCodeInput.value;
		const url = element.dataset.route + '?rest_language=' + this._lang;

		couponCodeInput.classList.remove('invalid');
		couponCodeInput.classList.remove('valid');
		couponCodeInput.parentNode.querySelectorAll('.input-error').forEach(error => {
			error.remove();
		});
		this.couponSummaryTarget.querySelectorAll('.general-success').forEach(error => {
			error.remove();
		});
		element.classList.add('loading');
		let response;

		await Axios.post(url, {
				code: couponCode
		})
				.then(res => {
					response = res.data.data;
				})
				.catch(error => {
					response = error.response.data.data;
				});

		element.classList.remove('loading');

		if (response && response.errors) {
			couponCodeInput.classList.add('invalid');
			const messageNode = document.createElement('span');
			messageNode.classList.add('input-error');
			messageNode.innerHTML = response.errors.code;
			couponCodeInput.parentNode.appendChild(messageNode);
			this.couponDiscountTarget.style.display = 'none';
			document.querySelector('form button[type=submit]').innerHTML = response.payNow;
			this.planTitleTargets.forEach(planTitle => {
				planTitle.innerHTML = response.planTitle;
			});
			this.planPriceTarget.innerHTML = response.planPrice;
		} else if (response && response.general_success) {
			const messageNode = document.createElement('div');
			messageNode.classList.add('general-success');
			messageNode.innerHTML = response.general_success;
			this.couponSummaryTarget.appendChild(messageNode);
			couponCodeInput.classList.add('valid');
		} else if (response && response.html) {
			document.querySelector('#page').insertAdjacentHTML('beforeend', response.html);
		} else {
			couponCodeInput.classList.add('valid');
			this.couponDiscountTarget.style.display = 'block';
			this.couponTotalDiscountTarget.innerHTML = response.totalDiscount;
			this.couponTotalPriceTarget.innerHTML = response.totalPrice;
			this.planTitleTargets.forEach(planTitle => {
				planTitle.innerHTML = response.planTitle;
			});
			this.planPriceTarget.innerHTML = response.planPrice;
			document.querySelector('form button[type=submit]').innerHTML = response.payNow;
		}
	}

	async selectClub(event) {
		event.preventDefault();
		const element = event.currentTarget;
		const clubId = element.dataset.clubId;
		const url = element.dataset.route + '?rest_language=' + this._lang;
		const from = element.dataset.from || '';

		let response;
		element.classList.add('loading');
		await Axios.post(url, {
			id: clubId,
			from: from
		})
				.then(res => {
					response = res.data.data;
				})
				.catch(error => {
					response = error.response.data.data;
				});

		if (response && response.redirect) {
			window.location.href = response.redirect;
		} else {
			element.classList.remove('loading');
		}
	}

	async selectPlan(event) {
		const element = event.currentTarget;
		const planId = element.dataset.planId;
		const pID = element.dataset.pid;
		const url = element.dataset.route + '?rest_language=' + this._lang;
		const track = element.dataset.track || '';

		let response;
		element.classList.add('loading');
		await Axios.post(url, {
			id: planId,
			pid: pID,
			track: track
		})
				.then(res => {
					response = res.data.data;
				})
				.catch(error => {
					response = error.response.data.data;
				});

		if (response && response.redirect) {
			window.location.href = response.redirect;
		} else if (response && response.totalPrice) {
			document.querySelector('input[data-checkout-target="couponCode"]').classList.add('valid');
			document.querySelector('[data-checkout-target="couponDiscount"]').style.display = 'block';
			document.querySelector('[data-checkout-target="couponTotalDiscount"]').innerHTML = response.totalDiscount;
			document.querySelector('[data-checkout-target="couponTotalPrice"]').innerHTML = response.totalPrice;
			document.querySelector('form button[type=submit]').innerHTML = response.payNow;
			document.querySelector('.modal').remove();
			element.classList.remove('loading');
		} else if (response && response.modal) {
			const modalElement = document.querySelector(`#planSurveyModal${response.modal_id}`);

			if (modalElement) {
				modalElement.remove();
			}

			document.body.insertAdjacentHTML('beforeend', response.modal);

			setTimeout(() => {
				const modalController = application.getControllerForElementAndIdentifier(document.querySelector(`#planSurveyModal${response.modal_id}`), 'modal');
				if (modalController) {
					modalController.showModal(document.querySelector(`#planSurveyModal${response.modal_id}`));
				}
				element.classList.remove('loading');
			}, 200);
		} else {
			element.classList.remove('loading');
		}
	}

	async selectPlanAndClub(event) {
		const element = event.currentTarget;
		const planId = element.dataset.planId;
		const clubId = element.dataset.clubId;
		const pID = element.dataset.pid;
		const url = element.dataset.route + '?rest_language=' + this._lang;
		const track = element.dataset.track || '';

		let response;
		element.classList.add('loading');
		await Axios.post(url, {
			plan_id: planId,
			club_id: clubId,
			pid: pID,
			track: track
		})
				.then(res => {
					response = res.data.data;
				})
				.catch(error => {
					response = error.response.data.data;
				});

		if (response && response.redirect) {
			window.location.href = response.redirect;
		} else if (response && response.modal) {
			const modalElement = document.querySelector(`#planSurveyModal${response.modal_id}`);

			if (modalElement) {
				modalElement.remove();
			}

			document.body.insertAdjacentHTML('beforeend', response.modal);

			setTimeout(() => {
				const modalController = application.getControllerForElementAndIdentifier(document.querySelector(`#planSurveyModal${response.modal_id}`), 'modal');
				if (modalController) {
					modalController.showModal(document.querySelector(`#planSurveyModal${response.modal_id}`));
				}
				element.classList.remove('loading');
			}, 200);
		} else {
			element.classList.remove('loading');
		}
	}

	back(event) {
		const element = event.currentTarget;

		if (element.dataset.back && element.dataset.current) {
			const backSelector = document.querySelector(`.${element.dataset.back}`);
			const currentSelector = document.querySelector(`.${element.dataset.current}`);

			backSelector.classList.add('d-block');
			backSelector.classList.remove('d-none');

			currentSelector.classList.remove('d-block');
			currentSelector.classList.add('d-none');
		}
	}

	async loadPaymentMethods(event) {
		const element = event.currentTarget;
		const paymentMethodsEl = document.querySelector('#paymentMethods');

		if (paymentMethodsEl) {
			paymentMethodsEl.classList.add('loading-block');
			element.tomselect.disable();

			let response;
			element.classList.add('loading');
			await Axios.get(`${element.dataset.route}?lang=${element.value}`)
					.then(res => {
						response = res.data.data;
					})
					.catch(error => {
						response = error.response.data.data;
					});

			if (response.success) {
				paymentMethodsEl.innerHTML = response.template;
			}

			paymentMethodsEl.classList.remove('loading-block');
			element.tomselect.enable();
		}
	}

	async addAddon(event) {
		const element = event.currentTarget;
		const addonId = element.dataset.addonId;
		const url = element.dataset.route + '?rest_language=' + this._lang;

		let response;
		element.classList.add('loading');
		await Axios.post(url, {
			id: addonId
		})
				.then(res => {
					response = res.data.data;
				})
				.catch(error => {
					response = error.response.data.data;
				});

		if (response.success) {
			let nextElement = element.parentElement.nextElementSibling;
			element.parentElement.classList.toggle('d-none');
			nextElement.classList.toggle('d-none');

			const price = parseFloat(element.dataset.itemPrice);

			window.dataLayer = window.dataLayer || [];
			window.dataLayer.push({ ecommerce: null });
			window.dataLayer.push({
				event: 'add_to_cart',
				ecommerce: {
					currency: 'EUR',
					value: price,
					items: [{
						item_id: String(element.dataset.addonId),
						item_name: element.dataset.itemName,
						item_category: 'addon',
						price: price,
						quantity: 1
					}]
				}
			});
		}

		element.classList.remove('loading');
	}

	async removeAddon(event) {
		const element = event.currentTarget;
		const addonId = element.dataset.addonId;
		const url = element.dataset.route + '?rest_language=' + this._lang;

		let response;
		element.classList.add('loading');
		await Axios.post(url, {
			id: addonId
		})
				.then(res => {
					response = res.data.data;
				})
				.catch(error => {
					response = error.response.data.data;
				});

		if (response.success) {
			let prevElement = element.parentElement.previousElementSibling;
			element.parentElement.classList.toggle('d-none');
			prevElement.classList.toggle('d-none');
		}

		element.classList.remove('loading');
	}

	async resendOtp(event) {
		const element = event.currentTarget;
		const url = element.dataset.route + '?rest_language=' + this._lang;
		const action = element.dataset.otpAction;
		const phone = document.querySelector(element.dataset.input).value;

		let response;
		element.classList.add('loading');

		try {
			response = await this.handlePostSubmit(url, {
				action: action,
				phone: phone
			});

			response = response.data.data;
		} catch (error) {
			response = error.response.data.data;
		}

		element.classList.remove('loading');
		if (response.general_success) {
			const messageNode = document.createElement('p');
			messageNode.classList.add('mb-0');
			messageNode.innerHTML = response.general_success;
			element.replaceWith(messageNode);
		}
	}

	toggleTitle() {
		const buyingForEls = document.querySelectorAll('input[name="for"]');
		const minorTitle = document.querySelector('#minorTitle');
		const selfTitle = document.querySelector('#selfTitle');

		if (buyingForEls && minorTitle && selfTitle) {
			buyingForEls.forEach(el => {
				el.addEventListener('change', () => {
					if (el.value === 'self') {
						minorTitle.classList.add('d-none');
						selfTitle.classList.remove('d-none');
					} else if (el.value === 'minor') {
						selfTitle.classList.add('d-none');
						minorTitle.classList.remove('d-none');
					}
				});
			});
		}
	}

	codeInputTargetConnected(element) {
		let debounce = null;
		let msg = document.querySelector('.code-msg');

		element.addEventListener('input', () => {
			clearTimeout(debounce);
			element.classList.remove('invalid', 'valid');
			msg.style.display = 'none';
			let err = element.parentElement.querySelector('.input-error');
			if (err) {
				err.remove();
			}

			debounce = setTimeout(async () => {
				if (!element.value) {
					return;
				}

				if (element.classList.contains('loading')) {
					return;
				}

				element.classList.add('loading', 'disabled');
				let r = await this.validateCode(element.value, element.dataset.onboarding);

				element.classList.remove('loading');

				if (r.valid) {
					element.classList.add('valid');
					msg.classList.remove('text-danger');
					msg.classList.add('text-success');
				} else {
					element.classList.add('invalid');
					msg.classList.remove('text-success');
					msg.classList.add('text-danger');
				}

				msg.innerHTML = r.message;
				msg.style.display = 'inline-block';
				element.classList.remove('disabled');
			}, 500);
		});
	}

	async resetPassword(event) {
		const element = event.currentTarget;
		const url = '/wp-json/api/checkout/reset-password?rest_language=' + this._lang;
		element.classList.add('loading');

		let response;

		try {
			response = await this.handlePostSubmit(url, {
				email: document.querySelector('input[name="email"]').value
			});
			response = response.data.data;
		} catch (error) {
			console.log(error);
			response = error.response.data;
		}

		element.classList.remove('loading');

		const generalMessages = element.parentNode.querySelectorAll('.err');
		generalMessages.forEach(msg => msg.remove());

		const createMessage = (text, type = 'danger') => {
			const messageNode = document.createElement('p');
			messageNode.classList.add('mb-0', 'mt-1', `text-${type}`, 'err');
			messageNode.innerHTML = text;
			return messageNode;
		};

		let messageNode;

		if (response.general_success) {
			messageNode = createMessage(response.general_success, 'success');
			element.replaceWith(messageNode);
		} else if (response.general_error) {
			messageNode = createMessage(response.general_error);
			element.parentNode.appendChild(messageNode);
		} else if (response.code === 'rate_limited') {
			messageNode = createMessage(response.message);
			element.parentNode.appendChild(messageNode);
		} else if (response.data?.errors?.email) {
			messageNode = createMessage(response.data.errors.email);
			element.parentNode.appendChild(messageNode);
		}
	}

	async validateCode(code, onboardingID) {
		const url = '/wp-json/api/onboarding/validate-code?rest_language=' + this._lang;

		let response;

		response = await this.handlePostSubmit(url, {
			code: code,
			onboarding_id: onboardingID
		});

		return response.data.data;
	}

	handlePostSubmit(url, data, config) {
		if (window.grecaptcha) {
			return new Promise((resolve) => {
				window.grecaptcha.ready(() => {
					resolve(window.grecaptcha.execute(document.querySelector('meta[name="global_recaptcha_site_key"]').content, { action: 'submit' }));
				});
			}).then(recaptchaToken => {
				data.recaptcha = recaptchaToken;

				return Axios.post(url, data, config);
			});
		}

		return Axios.post(url, data, config);
	}
}
